import React from "react";
import "./CartSidebar.css";
import { usePanier, getOutil, FRAIS_LIVRAISON } from "../../PanierContext";
import { Button } from "../ui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

interface CartSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  onCheckout: () => void;
}

const CartSidebar: React.FC<CartSidebarProps> = ({ isOpen, onClose, onCheckout }) => {
  const { panier, ajouterOutil, diminuerOutil, supprimerOutil, total } = usePanier();

  const handleCheckout = () => {
    onClose();
    onCheckout();
  };

  return (
    <>
      <div className={`cart-overlay ${isOpen ? "cart-overlay--visible" : ""}`} onClick={onClose} />
      <aside className={`cart-sidebar ${isOpen ? "cart-sidebar--open" : ""}`}>
        <div className="cart-sidebar__header">
          <h2>Mon panier</h2>
          <button className="cart-sidebar__close" onClick={onClose} aria-label="Fermer le panier">
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div className="cart-sidebar__body">
          {panier.length === 0 ? (
            <div className="cart-empty">
              <p>Votre panier est vide.</p>
              <Button variant="secondary" onClick={() => {
                onClose();
                document.getElementById("boutique")?.scrollIntoView({ behavior: "smooth" });
              }}>
                Voir la boutique
              </Button>
            </div>
          ) : (
            <>
              <ul className="cart-list">
                {panier.map((item) => {
                  const outil = getOutil(item.idOutil);
                  if (!outil) return null;
                  return (
                    <li key={outil.id} className="cart-item">
                      <img src={outil.image} alt={outil.nom} className="cart-item__img" />
                      <div className="cart-item__info">
                        <p className="cart-item__name">{outil.nom}</p>
                        <p className="cart-item__unit">{(outil.prix / 100).toFixed(2)} € / unité</p>
                        <div className="cart-item__qty">
                          <button onClick={() => diminuerOutil(outil.id)} aria-label="Diminuer">−</button>
                          <span>{item.nombre}</span>
                          <button onClick={() => ajouterOutil(outil.id)} aria-label="Augmenter">+</button>
                        </div>
                      </div>
                      <div className="cart-item__right">
                        <span className="cart-item__price">
                          {((outil.prix * item.nombre) / 100).toFixed(2)} €
                        </span>
                        <button
                          className="cart-item__remove"
                          onClick={() => supprimerOutil(outil.id)}
                          aria-label="Supprimer"
                        >
                          ✕
                        </button>
                      </div>
                    </li>
                  );
                })}
              </ul>

              <div className="cart-summary">
                <div className="cart-summary__line">
                  <span>Sous-total</span>
                  <span>{(total / 100).toFixed(2)} €</span>
                </div>
                <div className="cart-summary__line">
                  <span>Frais de livraison</span>
                  <span>{FRAIS_LIVRAISON.toFixed(2)} €</span>
                </div>
                <div className="cart-summary__line cart-summary__line--total">
                  <span>Total</span>
                  <span>{((total / 100) + FRAIS_LIVRAISON).toFixed(2)} €</span>
                </div>
              </div>

              <Button variant="primary" size="lg" fullWidth onClick={handleCheckout}>
                Commander
              </Button>
            </>
          )}
        </div>
      </aside>
    </>
  );
};

export default CartSidebar;
